export enum KeyRoots {
  TIME_OFF_HEADER_DATA = 'timeOffHeaderData',
  TIME_OFF_TABLE_ROW = 'timeOffTableRow',
  TIME_OFF_AVATAR_GROUP_ITEM = 'timeOffAvatarGroupItem',
  TIME_OFF_TEAM_VACATION_COMP = 'timeOffTeamVacationComp',
  TIME_OFF_MOBILE_CALENDAR_ROW = 'timeOffMobileCalendarRow',
  TIME_OFF_MOBILE_CALENDAR_CELL = 'timeOffMobileCalendarCell',
  TIME_OFF_MOBILE_CALENDAR_CELL_ELSE = 'timeOffMobileCalendarCellElse',
  TIME_OFF_TEAM_VACATION_CIRCLE = 'timeOffTeamVacationCircle',
  TIME_OFF_REQUEST_WIDGET_STATUS_FILTER_OPTIONS = 'timeOffRequestWidgetStatusFilterOptions',
  TIME_OFF_REQUEST_WIDGET_FILTER_BY_DATE__OPTIONS = 'timeOffRequestWidgetFilterByDateOptions',
  TIME_OFF_REQUEST_WIDGET_MONTH_IN_YEAR_OPTION = 'timeOffRequestWidgetMonthInYearOption',
  TIME_OFF_SUMMARY_SECTION = 'timeOffSummarySection',
  TIME_OFF_SUMMARY_SECTION_PAYED_DAYS = 'timeOffSummarySectionPayedDays',
  TIME_OFF_SUMMARY_SECTION_BONUS_DAYS = 'timeOffSummarySectionBonusDays',
  TIME_OFF_TEAM_WIDGET_PERSONA = 'timeOffTeamWidgetPersona',

  TIME_SHEET_MOBILE_FOOTER_CELL = 'timeSheetMobileFooterCell',
  TIME_SHEET_DESKTOP_FOOTER_CELL = 'timeSheetDesktopFooterCell',
  MOBILE_CALENDAR_CELL = 'mobileCalendarCell',
  MOBILE_CALENDAR_CELL_EMPTY = 'mobileCalendarCellEmpty',
  TEAM_VACATION_CIRCLE = 'teamVacationCircle',
}
